<template>
  <div>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-btn color="blue darken-1" flat slot="activator" small>
        <v-icon color="blue darken-1">add</v-icon>New Package
      </v-btn>
      <v-card>
        <v-toolbar flat dense color="primary" dark>
          <v-toolbar-title class="title">New Package</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon class="mx-0" @click="close">
            <v-icon color="white">clear</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <form @submit.prevent="save">
              <v-layout wrap>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-validate="'required'"
                    :error-messages="errors.collect('packageName')"
                    data-vv-name="packageName"
                    v-model="packageName"
                    label="Package Name"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-validate="'required'"
                    :error-messages="errors.collect('locations')"
                    data-vv-name="locations"
                    label="Locations"
                    type="number"
                    v-model="locations"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-validate="'required'"
                    :error-messages="errors.collect('projects')"
                    data-vv-name="projects"
                    label="Projects"
                    type="number"
                    v-model="projects"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-validate="'required'"
                    :error-messages="errors.collect('expertise')"
                    data-vv-name="expertise"
                    label="Expertise"
                    type="number"
                    v-model="expertise"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12>
                  <v-textarea
                    v-validate="'required'"
                    :error-messages="errors.collect('description')"
                    data-vv-name="description"
                    v-model="description"
                    name="description"
                    label="About the package"
                    required
                  ></v-textarea>
                </v-flex>

                <v-flex xs12 sm12 md12>Package Options</v-flex>

                <v-flex xs12>
                  <v-btn @click="openOptionModal()" flat class="primary--text">
                    <v-icon left>add</v-icon>Add Option
                  </v-btn>

                  <!-- start of option dialog -->
                  <v-dialog v-model="optionDialog" persistent max-width="650">
                    <v-card>
                      <v-toolbar dense color="primary" dark>
                        <v-toolbar-title>New Package Option</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click.native="optionDialog=false">
                          <v-icon>clear</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text>
                        <v-layout wrap>
                          <v-flex class="pa-2" xs12 sm6>
                            <v-text-field
                              label="Time"
                              v-model="option.time"
                            ></v-text-field>
                          </v-flex>

                          <v-flex class="pa-2" xs12 sm6>
                            <v-text-field label="Cost" v-model="option.cost" required></v-text-field>
                          </v-flex>

                          <v-flex class="pa-2" xs12 sm6>
                            <v-text-field label="Duration" v-model="option.duration" required></v-text-field>
                          </v-flex>
                          <v-flex class="pa-2" xs12 sm6>
                            <v-btn color="purple darken-1" flat @click="addOption">
                              <v-icon left>add</v-icon>Add
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions></v-card-actions>
                    </v-card>
                  </v-dialog>
                  <!-- end of option dialog -->
                </v-flex>

                <v-flex xs12 sm6>
                  <div class="subheading" v-for="(item, i) in options" :key="i">
                    <v-btn small flat>{{ i+1 }}. {{ item.time }} - {{item.cost}}</v-btn>
                    <v-btn @click="removeOption(i)" small flat icon class="right warning--text">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </div>
                </v-flex>

                <v-flex xs12 sm12 md12>Features</v-flex>

                <v-flex xs12>
                  <v-btn @click="openFeatureModal()" flat class="primary--text">
                    <v-icon left>add</v-icon>Add Feature
                  </v-btn>

                  <!-- start of feature dialog -->
                  <v-dialog v-model="featureDialog" persistent max-width="500">
                    <v-card>
                      <v-card-title class="title">New Feature Entry</v-card-title>

                      <v-card-text>
                        <v-layout wrap v-if="dialog">
                          <v-flex class="pa-1" xs12 sm12>
                            <v-text-field label="Feature" v-model="feature" required></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="purple darken-1"
                          flat
                          @click.native="featureDialog = false"
                        >Cancel</v-btn>
                        <v-btn color="purple darken-1" flat @click="addFeature">Add</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <!-- end of feature dialog -->
                </v-flex>

                <v-flex xs12 sm6>
                  <div class="subheading" v-for="(item, i) in features" :key="i">
                    <v-btn small flat>{{ i+1 }}. {{ item }}</v-btn>
                    <v-btn @click="removeFeature(i)" small flat icon class="right warning--text">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </div>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-btn
                    class="blue darken-1"
                    dark
                    type="button"
                    :loading="loader"
                    @click="save"
                    small
                    flat
                  >
                    <v-icon>save</v-icon>Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-container>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
    <!-- snackbar  -->
    <app-snackbar ref="mySnackbar"></app-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NewMembership",
  data() {
    return {
      dialog: false,
      loader: false,
      optionDialog: false,
      featureDialog: false,
      packageName: null,
      locations: null,
      description: null,
      expertise: null,
      projects: null,
      features: [],
      options: [],
      feature: null,
      plan: {},
      option: {},
      membership: {}
    };
  },
  computed: {},
  methods: {
    save() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          const data = {
            name: this.packageName,
            locations: this.locations,
            projects: this.projects,
            description: this.description,
            expertise: this.expertise,
            plan: this.plan,
            options: this.options,
            features: this.features
          };
          console.log(data, 'd');
          this.loading = true;
          const self = this;
          const res = this.$store
            .dispatch("post", { url: "/packages", data })
            .then(res => {
              self.loading = false;
              self.dialog = false;
            })
            .finally(() => {
              location.reload();
            });
        }
      });
    },
    addOption() {
      if (
        this.option.duration == null ||
        this.option.time == null ||
        this.option.cost == null
      ) {
        this.$refs.mySnackbar.show("Please fill all fields", "red");
      } else {
        const option = this.option;
        this.options.push(option);
        this.option = {};
        this.optionDialog = false;
      }
    },
    addFeature() {
      const feature = this.feature;
      this.features.push(feature);
      this.feature = null;
      this.featureDialog = false;
    },
    removeOption(key){
      this.options.splice(key, 1);
    },
    removeFeature(key){
      this.features.splice(key, 1);
    },
    openOptionModal() {
      this.optionDialog = true;
    },
    openFeatureModal() {
      this.featureDialog = true;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
